import React from 'react';
import { useLocation, useParams, useNavigate } from 'react-router-dom'
import { Fetcher } from '@garpix/fetcher/fetcher/storeon'
import TaskPage from './TaskPage'
import SportsmanSchedulePage from './SportsmanSchedulePage'
import Error500Page from './Error500Page';
import Error404Page from './Error404Page'
import CreateTaskPage from './CreateTaskPage';
import CertificatePage from './CertificatePage';
import CreateCertificatePage from './CreateCertificatePage';
import StatisticsPage from './StatisticsPage';
import PageLayout from '../layout/PageLayout';
import ContractPage from './ContractPage';
import AuthorizationPage from './AuthorizationPage';
import { FlyListPage } from './FlyingListPage';

export const PAGE_TYPES = {
  HomePage: SportsmanSchedulePage,
  TaskPage,
  CertificatePage,
  StatisticsPage,
  CreateTaskPage,
  FlyListPage,
  CreateCertificatePage,
  SportsmanSchedulePage,
  ContractPage,
  401: AuthorizationPage,
  403: AuthorizationPage,
  404: Error404Page,
  500: Error500Page
};

const Combine = (props: any): React.ReactElement => {
  const params = useParams()
  const location = useLocation()
  const navigate = useNavigate()
  const match = {
    params
  }

  return (
    <Fetcher match={match}
      navigate={navigate}
      location={location}
      paramsKey='*'
      {...props}
    >

      {(data: { [p: string]: any } = {}) => {
        const pageType = data?.pageType
        const page = data?.page
        if (pageType === undefined) {
          return null
        }
        // @ts-ignore
        const Page = PAGE_TYPES[pageType]
        return <PageLayout title={page?.object?.title}><Page {...page} /></PageLayout>
      }}
    </Fetcher>
  );
};

export default Combine;
